export default __webpack_public_path__ + "static/media/spin.9f9a64be.svg";